"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelectAllButton = exports.StyledHLQATasksBulkSelectionPanel = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHLQATasksBulkSelectionPanel = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledSelectAllButton = (0, styled_components_1.default)(ui_components_1.Button) `
  margin-left: ${({ theme }) => theme.spacing(1)};
  margin-right: auto;
`;
